import { Component, EventEmitter, Input, Output } from '@angular/core';

import { UserWeb } from '../user.model';

@Component({
  selector: 'cc-user-permission-toggle',
  templateUrl: './user-permission-toggle.component.html',
  styleUrls: ['./user-permission-toggle.component.scss'],
})
export class UserPermissionToggleComponent {
  @Input() permissionOptions: string[];
  @Input() canUpdateUserPermission: boolean;
  @Input() user: UserWeb;

  @Output() onUpdatePermission = new EventEmitter();
}
